import type { ChargeDTO, CustomerDTO, SaleDTO } from '../../core/models';
import type { ReconciliationLineDTO } from '../../services/reconciliation.service';

export function reconciliationSaleLabel(line: ReconciliationLineDTO): string {
  return saleDtoLabel(line.sale);
}

export function reconciliationChargeLabel(line: ReconciliationLineDTO): string {
  return chargeDtoLabel(line.charge);
}

export function reconciliationCustomerLabel(line: ReconciliationLineDTO): string {
  return customerDtoLabel(line.customer ?? line.sale?.customer);
}

export function saleDtoLabel(sale?: SaleDTO | null): string {
  const number = sale?.number?.trim();
  if (number) return number;
  if (sale?.id != null) return `#${sale.id}`;
  return '—';
}

export function chargeDtoLabel(charge?: ChargeDTO | null): string {
  if (!charge) return '—';
  if (charge.paymentNumber != null && charge.numberOfPayments != null) {
    return `Pago ${charge.paymentNumber} de ${charge.numberOfPayments}`;
  }
  return charge.id != null ? `Recibo #${charge.id}` : '—';
}

export function customerDtoLabel(customer?: CustomerDTO | null): string {
  if (!customer) return '—';
  return customer.comercialName || customer.legalName || (customer.id != null ? `Cliente #${customer.id}` : '—');
}
